module.exports = __webpack_public_path__ + "img/bb_img2.5c3f8d12.png";